(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-dynamic-urls-dropdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('link-list-dropdown')) {
    customElements.define('link-list-dropdown', class LinkListDropdown extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-lld-trigger]');
        this.panel = this.querySelector('[data-lld-panel]');
        if (!this.trigger || !this.panel) return;

        this.handleTriggerClick = () => {
          if (this.isOpen()) {
            this.close();
          } else {
            this.open();
          }
        };

        this.handleDocumentClick = (event) => {
          if (this.isOpen() && !this.contains(event.target)) {
            this.close();
          }
        };

        this.handleKeydown = (event) => {
          if (event.key === 'Escape' && this.isOpen()) {
            this.close();
            this.trigger.focus();
          }
        };

        this.handleFocusOut = (event) => {
          if (this.isOpen() && event.relatedTarget && !this.contains(event.relatedTarget)) {
            this.close();
          }
        };

        this.trigger.addEventListener('click', this.handleTriggerClick);
        document.addEventListener('click', this.handleDocumentClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('focusout', this.handleFocusOut);
      }

      disconnectedCallback() {
        if (this.trigger) this.trigger.removeEventListener('click', this.handleTriggerClick);
        document.removeEventListener('click', this.handleDocumentClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('focusout', this.handleFocusOut);
      }

      isOpen() {
        return this.trigger.getAttribute('aria-expanded') === 'true';
      }

      open() {
        this.trigger.setAttribute('aria-expanded', 'true');
        this.classList.add('is-open');
      }

      close() {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.classList.remove('is-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
